import CLASS_NAMES from "../constants/css-constants.es6.js";
import ContentUtils from "../utils/content-utils.es6.js";
import Element from "./element.es6.js";

export default class Field extends Element {
  get item() {
    const singleNestedItemSelector = `> .${CLASS_NAMES.FIELD_ITEM}`;
    const multipleNestedItemsSelector = `> .${CLASS_NAMES.FIELD_ITEMS} > .${CLASS_NAMES.FIELD_ITEM}`;
    const selector = `${singleNestedItemSelector}, ${multipleNestedItemsSelector}`;

    const nestedItem = new Element({
      parentElement: this,
      selector,
    });

    const nestedItemCount = nestedItem.$().length;
    if (nestedItemCount) {
      return nestedItem;
    }

    return this;
  }

  constructor({ machineName, parentElement }) {
    const className = ContentUtils.fieldMachineNameToClassName(machineName);
    const selector = `.${className}`;

    super({ parentElement, selector });

    this.id = ContentUtils.machineNameToId(machineName);
  }
}
